import React from "react";
import protect from "../images/icon-protect.png";
import tag from "../images/icon-tag.png";
import reload from "../images/icon-reload.png";
import rocket from "../images/icon-rocket.png";
import support from "../images/icon-support.png";

const AdvantageCard = ({ icon, title }) => {
  return (
    <div className="group flex flex-col sm:flex-row items-center p-4 rounded-xl bg-white hover:bg-yellow-50 transition-all duration-300 border border-gray-100 hover:border-yellow-200 shadow-sm hover:shadow-md transform hover:-translate-y-1">
      <div className="flex justify-center items-center w-16 h-16 rounded-full bg-yellow-50 group-hover:bg-yellow-100 transition-colors duration-300">
        <img 
          className="h-8 sm:h-10 transition-transform duration-300 group-hover:scale-110" 
          src={icon} 
          alt={title}
        />
      </div>
      <p className="sm:ml-4 font-medium text-gray-700 group-hover:text-gray-900 sm:mt-0 mt-3 text-center sm:text-left sm:text-[15px] text-[14px] transition-colors duration-300">
        {title}
      </p>
    </div>
  );
};

const Advantages = () => {
  const advantages = [
    { icon: protect, title: "100% təhlükəsiz ödəniş" },
    { icon: tag, title: "24/7 əlaqə imkanı" },
    { icon: rocket, title: "Çox məhsul alışında endirimlər" },
    { icon: support, title: "Münasib qiymətlər" }
  ];

  return (
    <section className="py-[30px] bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl sm:text-3xl font-bold text-center text-gray-800 mb-8">
          Niyə bizi <span className="text-yellow-500">seçməlisiniz?</span>
        </h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {advantages.map((advantage, index) => (
            <AdvantageCard 
              key={index} 
              icon={advantage.icon} 
              title={advantage.title} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Advantages;
